import { Focusable } from '../../accessibility/focusable'
import { stopBodyScroll, allowBodyScroll } from '../controls/controlBodyScroll'
import { AutoComplete } from './autocomplete'
import { HeroAutoComplete } from './hero-autocomplete'
const openClass = 's-dialog--open'

class SearchPanel {
  constructor (elem) {
    if (elem == null) {
      return
    }

    this.elem = elem
    this.id = this.elem.id
    this.focusState = new Focusable(elem)
    this.form = this.elem.querySelector('form')
    this.searchBox = this.elem.querySelector('[data-search-input]')
    this.init()
  }

  init () {
    this.setAutocompleteType()
    this.setupDialogEvents()
  }

  setAutocompleteType () {
    const autoCompleteElem = this.elem.querySelector('[data-autocomplete]')
    const heroAutoCompleteElem = this.elem.querySelector('[data-hero-autocomplete]')

    if (autoCompleteElem) {
      this.autoComplete = new AutoComplete(autoCompleteElem)
    } else if (heroAutoCompleteElem) {
      this.autoComplete = new HeroAutoComplete(heroAutoCompleteElem)
    }
  }

  setupDialogEvents () {
    this.focusState.onEscape(() => this.close())
  }

  open () {
    requestAnimationFrame(() => {
      this.elem.classList.add(openClass)
      document.dispatchEvent(new CustomEvent('recheck-script'))
      if (this.elem.scrollTo) {
        this.elem.scrollTo(0, 0)
      }

      stopBodyScroll()
      setTimeout(() => {
        this.focusState.setup()
        this.focusState.focusFirst()
      }, 500)
    })
  }

  close () {
    requestAnimationFrame(() => {
      this.elem.classList.remove(openClass)
      console.log('close SearchPanel')
      allowBodyScroll()
      if (this.opener !== null) {
        this.opener.focus()
        this.opener = null
      }
    })
  }

  populateAutocomplete (data) {
    if (data == null) {
      data = [{
        url: '#0',
        title: 'Travelling safely with your dog',
        breadcrumb: ['Support', 'Travelling with us']
      },
      {
        url: '#0',
        title: 'Travelling safely with your dog',
        breadcrumb: ['Support', 'Travelling with us']
      },
      {
        url: '#0',
        title: 'Travelling safely with your dog',
        breadcrumb: ['Support', 'Travelling with us']
      },
      {
        url: '#0',
        title: 'Travelling safely with your dog',
        breadcrumb: ['Support', 'Travelling with us']
      }]
    }

    this.autoComplete.open(data, this.searchBox.value)
  }
}

function setupSearchPanel () {
  const searchDialog = document.querySelector('[data-search-dialog]')

  if (searchDialog) {
    return new SearchPanel(searchDialog)
  }
}

export {
  SearchPanel,
  setupSearchPanel
}
